import React from 'react';
import SkibusIcon from '../atoms/icons/skibus';
import SkiliftIcon from '../atoms/icons/skilift';
import TownCentreIcon from '../atoms/icons/towncentre';

const HotelLabels = ({ hotel }) => {
  return (
    <div className="hidden xs:flex absolute bottom-0 bg-white rounded-lg m-2 md:m-4 px-0 px-2">
      <div
        className={`flex items-center flex-nowrap bg-white rounded-l-lg pl-2 mr-[1px]`}
      >
        <div className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}>
          <SkiliftIcon />
        </div>
        <span className="text-xs pr-2">{hotel.distanceToLift} m</span>
      </div>
      <div className={`flex items-center flex-nowrap bg-white pl-2 mr-[1px]`}>
        <div className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}>
          <SkibusIcon />
        </div>
        <span className="text-xs pr-2">{hotel.distanceToSkibus} m</span>
      </div>
      <div
        className={`flex items-center flex-nowrap bg-white rounded-r-lg pl-2`}
      >
        <div className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}>
          <TownCentreIcon />
        </div>
        <span className="text-xxs pr-2">{hotel.distanceToTownCentre} m</span>
      </div>
    </div>
  );
};

export default HotelLabels;
